import { Handle, type NodeProps, type Node } from "@xyflow/react";
import type { WorkflowNodeData } from "../../lib/workflow-graph";
import { handlePositions, type HandleDirection } from "./handles";
import LinkHandles from "./LinkHandles";
import styles from "./WorkflowNode.module.css";

export default function BranchNode({ data }: NodeProps<Node>) {
  const d = data as unknown as WorkflowNodeData & {
    direction?: HandleDirection;
  };
  const { source, target } = handlePositions(d.direction);
  return (
    <div className={`${styles.card} ${styles.branch}`}>
      <Handle type="target" position={target} />
      <p className={styles.kind}>Branch</p>
      <p className={styles.label}>{d.label}</p>
      {d.subtitle && <p className={styles.subtitle}>{d.subtitle}</p>}
      <Handle type="source" position={source} />
      <LinkHandles />
    </div>
  );
}
